import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiCheckIfHiddenStore, apiGetHiddenStoreItem } from "./service";

export const useCheckIfHiddenStore = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.STORE_CODE_SETTING, params.code],
    queryFn: () =>
      apiCheckIfHiddenStore(params).then((res: any) => res.data.data),
    ...options,
  });
};

export const useGetHiddenStoreItem = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.STORE_CODE, params.code],
    queryFn: () =>
      apiGetHiddenStoreItem(params).then((res: any) => res.data.data),
    ...options,
  });
};
